import clsx from "clsx"

import { BaseInputHelpText } from "@atoms/InputHelpText/InputHelpText"
import { Label } from "@atoms/index"

import { AlertBanner } from "@molecules/index"

import styles from "./FormModule.module.scss"
import { FormModuleProps } from "./FormModule.types"

export default function FormModule(props: FormModuleProps) {
    const { label, supportText, banner, children, className, isError, errorMessage, ...rest } = props

    const labelIsString = typeof label === "string"

    return (
        <div className={clsx(styles.base, className)} {...rest}>
            <div className={styles.labelAndSupportText}>
                {label ? <Label {...(labelIsString ? { label } : label)} /> : null}
                {supportText ? <div className={styles.supportText}>{supportText}</div> : null}
            </div>
            {banner && <AlertBanner {...banner} />}
            {children}
            {isError === true && typeof errorMessage === "string" && (
                <BaseInputHelpText status="error" showIcon={true} message={errorMessage} />
            )}
        </div>
    )
}
